var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const baseURL = process.env.API_URL || '/api';
// Own instance: the screen is public and must never send the host's bearer token,
// so every request gets exactly these headers and nothing from axios defaults.
const client = axios.create({ baseURL, timeout: 8000 });
client.interceptors.request.use((config) => {
    var _a;
    return (Object.assign(Object.assign({}, config), { headers: Object.assign({ 'Content-Type': 'application/json' }, (((_a = config.headers) === null || _a === void 0 ? void 0 : _a['X-Screen-Token']) ? { 'X-Screen-Token': config.headers['X-Screen-Token'] } : {})) }));
});
export const createScreenSession = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield client.post('/v1/screen/create');
    return response.data;
});
export const fetchScreenState = (token) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield client.get('/v1/screen/state', {
        headers: { 'X-Screen-Token': token },
    });
    return response.data;
});
